// @flow
import React, { type Node } from 'react';
import cn from 'classnames';

import * as types from 'app/common/constants/identifiers/types';

import IconByType from './icon-by-type';
import MarkByType from './mark-by-type';

import styles from './icon-by-type-with-marks.module.scss';;


type Props = {
  type: $Values<typeof types>,
  className?: string,
}

const IconByTypeWithMarks = ({ type, className }: Props): Node => {
  return (
    <div className={cn(styles.root, className)}>
      <IconByType type={type} />
      <MarkByType type={type} className={styles.marks} />
    </div>
  );
};

export default IconByTypeWithMarks;
